import { render, staticRenderFns } from "./BaseBIPage.vue?vue&type=template&id=523dc61c&scoped=true"
import script from "./BaseBIPage.vue?vue&type=script&lang=ts"
export * from "./BaseBIPage.vue?vue&type=script&lang=ts"
import style0 from "./BaseBIPage.vue?vue&type=style&index=0&id=523dc61c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523dc61c",
  null
  
)

export default component.exports